export enum OperationTypes {
  START = "DESENCRIPTAR_PRESTADOR_START",
  SUCCESS = "DESENCRIPTAR_PRESTADOR_SUCCESS",
  ERROR = "DESENCRIPTAR_PRESTADOR_ERROR",
  CARGAR_ARCHIVOS_START = "CARGAR_ARCHIVOS_START",
  CARGAR_ARCHIVOS_SUCCESS = "CARGAR_ARCHIVOS_SUCCESS",
  CARGAR_ARCHIVOS_ERROR = "CARGAR_ARCHIVOS_ERROR",
}

export interface IPrestador {
  prestador: string
  valorEncriptado: string
}

export interface ISubirArchivos {
  fd: FormData,
  archivos: File[]
}

export interface IArchivosSubidos {
  isUploading: boolean
  archivosSubidos?: File[]
  error?: string
}

export interface IDesencriptarPrestadorStart {
  type: OperationTypes.START
  payload: string
}

interface IDesencriptarPrestadorSuccess {
  type: OperationTypes.SUCCESS
  payload: IPrestador
}

interface IDesencriptarPrestadorError {
  type: OperationTypes.ERROR
  payload: string
}

interface ICargarArchivosStart {
  type: OperationTypes.CARGAR_ARCHIVOS_START
  payload: ISubirArchivos
}

interface ICargarArchivosSuccess {
  type: OperationTypes.CARGAR_ARCHIVOS_SUCCESS
  payload: IArchivosSubidos
}

interface ICargarArchivosError {
  type: OperationTypes.CARGAR_ARCHIVOS_ERROR
  payload: IArchivosSubidos
}

export type OperationActions =
  | IDesencriptarPrestadorStart
  | IDesencriptarPrestadorSuccess
  | IDesencriptarPrestadorError
  | ICargarArchivosStart
  | ICargarArchivosSuccess
  | ICargarArchivosError;
